import { c as _c } from "react/compiler-runtime";
import Image from 'next/image'; // ALLOW-RAW-IMG: static resolved seal, not user content

import { cn } from '@/lib/ui/utils';
interface SettledSealProps {
  className: string;
}

/** Static seal used wherever a resolved winning outcome is identified. */
export function SettledSeal(t0) {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("inline-block", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Image src="/images/debate-settled.png" alt="" width={168} height={168} className="size-full object-contain" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <span aria-hidden="true" className={t1}>{t2}</span>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}